import { useDeleteAtmCompany } from "./api/deleteAtmCompany";
import { Button } from "reactstrap";


const DeleteAtmCompany = ({handleCloseModal, atmCompanyId}: DeleteAtmCompanyProps)  => {
  
  const deleteAtmCompanyMutation = useDeleteAtmCompany({ atmCompanyId});
  const handleSubmit = async (): Promise<void> => {
    deleteAtmCompanyMutation.mutateAsync({ 
      atmCompanyId: atmCompanyId
    })

    handleCloseModal();
  }

  return (
    <>
        <label>Είστε σίγουροι οτι θέλετε να διαγράψετε την Εταιρία;</label>
        <div>
          <Button style={{ margin: "10px" }} onClick={handleCloseModal}>Ακύρωση</Button>
          <Button style={{ margin: "10px" }} color='danger' onClick={handleSubmit}>Διαγραφή</Button>
        </div>
    </>
  )
}

interface DeleteAtmCompanyProps{
  atmCompanyId: number;
  handleCloseModal: () => void;
}

export default DeleteAtmCompany;